import React, {useEffect, useReducer} from "react";
import Html from "./html";
import { loadMessages} from "./service";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import FormSubmit from "./components/formSubmit";
import CardWithHeaderTemplate from "../../common/cardWithHeaderTemplate";
import OffcanvasTemplate from "../../common/offcanvasTemplate";
import { getUserInfo } from "../../storage";
import { usersRef } from "../../firebase";

const Chat = ({
    show,
    handleClose,
    is_inbox,
    header
}) => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        let unsubscribe;
        const fetchData = async () => {
            unsubscribe = await loadMessages(dispatch)
        };

        fetchData();

        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);

    useEffect(() => {
        // Get user info
        const user_info = getUserInfo();
        const documentId = user_info?.customer_firebase_document_id?.trim();
        if (!documentId) return;
        const ref = usersRef.doc(documentId);

        ref.update({
            user_last_message_seen_user: user_info.customer_firebase_document_id,
            user_last_message_seen_timestamp: new Date().getTime() 
        });
    }, []);

    if(is_inbox){
        return (
            <Context.Provider value={{state, dispatch}}>
                <CardWithHeaderTemplate
                    header={header} 
                    body={<Html/>} 
                    footer= {
                        <div className="card-footer d-block">
                            <FormSubmit/>
                        </div>
                    }
                    extraCardClassName = {`blur shadow-blur max-height-vh-80 h-fix-100 min-height-vh-70`}
                    extraBodyClassName = {`overflow-auto overflow-x-hidden chat-body-height`}
                />
            </Context.Provider>
        );
    }else{
        return(
            <Context.Provider value={{state, dispatch}}>
                <OffcanvasTemplate
                    open = {show}
                    handleClose = {() => handleClose()} 
                    placement = {'end'}  
                    title = {"SUPPORT"}
                    body = {<Html/>} 
                    footer = {
                        <div className="container">
                            <div className="row" style={{marginTop: '10px'}}>
                                <div className="col">
                                    <div className="d-grid gap-2 mb-3" >
                                        <FormSubmit/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    } 
                    style={{
                        top: '10%',
                        bottom : '10%', 
                        borderRadius: "5px",
                        right: '2%'
                    }}
                />
            </Context.Provider>
        )
    }
} 

export default Chat;
